/**
 * Finds the media-scoped channel Alt entry for one (asset, listing) shared media.
 */
export default function resolveChannelAltEntry(asset, listingId) {
  const entries = asset?.channelAlt || [];
  return entries.find((entry) => String(entry.listingId) === String(listingId)) || null;
}
